export var isTouchDevice = function () { return navigator.maxTouchPoints > 0; };
export var openShareDialog = function (url, title, text) {
    return navigator.share({
        url: url,
        title: title,
        text: text,
    });
};
